import React from 'react'
import classnames from 'classnames'

export default function FormGroup(props) {
  const className = {
    'form-group': true,
    'has-dangerzz': props.hasError
  }
  if (props.className) {
    className[props.className] = true
  }
  return <div className={classnames(className)}>{props.children}</div>
}



// WEBPACK FOOTER //
// ./src/containers/formTemplate/FormGroup.tsx